import { IOrderDetail } from '@pu/mpp-ui/components/order-detail';
import { IOrderDisplay } from 'core/model/interfaces/order.interface';
import { ordersService } from 'core/services/orders/orders.service';
import type { TSliceExtraReducer } from 'core/store';
import { getCustomerIdFromCheckout } from 'core/store/checkout/checkout-state.utils';
import { createAppAsyncThunk } from 'core/store/store.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IOrdersState } from '../types';

export const getOrderDetailAction = createAppAsyncThunk<
  IOrderDetail,
  { orderId: IOrderDisplay['id']; sourceId: number }
>(`${SLICE_NAMESPACE}/getOrderDetail`, ({ orderId, sourceId }, { getState }) => {
  const { checkout } = getState();

  const customerId = getCustomerIdFromCheckout(checkout);
  return ordersService.getOrderDetail(orderId, sourceId, customerId);
});

export const getOrderDetailReducer: TSliceExtraReducer<IOrdersState> = builder => {
  builder
    .addCase(getOrderDetailAction.pending, state => {
      state.loadingDetail = true;
    })
    .addCase(getOrderDetailAction.fulfilled, (state, { payload }) => {
      state.loadingDetail = false;
      state.errorDetail = null;
      state.orderDetail = payload;
    })
    .addCase(getOrderDetailAction.rejected, (state, { error }) => {
      state.loadingDetail = false;
      state.errorDetail = error;
    });

  return builder;
};
